export default "__VITE_ASSET__B$Vpvikz__"